// extracted by mini-css-extract-plugin
export var note = "notes-module--note--77af5";
export var notes = "notes-module--notes--603a5";
export var wide = "notes-module--wide--5664c";